module.exports = {
    presentation: {
      noData: "没有数据",
      noScriptToPlay: "此演示文稿没有可播放的脚本.",
      loading: "加载中...",
      end:{
        title: "联系我们",
        nameRequired: "名称是必填项",
        emailRequired: "邮箱是必填项",
        emailNoValid: "该邮箱无效，请重新输入",
        phoneNoValid: "该电话号码无效，请重新输入",
        form: {
          name: "名称",
          email: "邮箱",
          phone: "电话",
          company: "公司",
          message: "信息",
        },
        contactUs: "联系我们",
        email: "邮箱",
        phone: "电话号码",
        noData:'暂无推荐视频',
        recommendedVideo: "推荐视频",
        ThankSupport: "谢谢您的支持",
        send:"发送",
        reload:"重播",
        share:"分享",
        copyNotify:"分享路径已经复制到粘贴板",
        btnText:'号召',
        impression:'点击量',
        playCount: '播放量',
        createdAt: '创建时间',
        errorLink: '很抱歉，该链接无效。'
      }
    }
  };